import React, { useState, useRef } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import {
  Typography,
  TextField,
  Button,
  Modal,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  Autocomplete,
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Swal from "sweetalert2";
import { generateBOQ, dataProductList, checkTorFormsExist } from "../Service";
import LoadingButton from "@mui/lab/LoadingButton";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useParams } from "react-router-dom";
import BtnUpdFileIcon from "../../img/UploadFileWhite.png";
import "../../styles/customSwalStyles.css";
import EditIcon from "@mui/icons-material/Edit";
import AddProduct from "./AddProduct";
import SearchMore from "./SearchMore";
import { addLog } from "../../utils/addLog";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { exportFormBOQ } from "../../forms/exportFormBOQ";
import { useTranslation } from "react-i18next";
import { dataAccessPermission } from "../../utils/dataAccessPermission";
import AddJob from "./AddJob";
import Unauthorized from "../Unauthorized";
import { signOut } from "../../utils/signOut";
import DataEntry from "./DataEntry";
import { exportFormQT } from "../../forms/exportFormQT";
import PageNotFound from "../PageNotFound";
import { exportFormTOR } from "../../forms/exportFormTOR";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};

const styleModaldelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  height: 200,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 3,
};

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const GenBOQ = () => {
  const [t, i18n] = useTranslation("global");
  const { team } = useParams();
  // Convert team by replace - to _ for matching with role data
  const teamParam = team.replace(/-/g, "_").toLowerCase();
  const isCallGenBOQ = team !== "lbd" ? true : false;

  const [userData, setUserData] = React.useState(
    JSON.parse(sessionStorage.getItem("authUserData"))
  );
  const [userRole, setUserRole] = React.useState(
    JSON.parse(sessionStorage.getItem("authUserRole"))
  );
  const [boqData, setBoqData] = useState([]);
  const [selected, setSelected] = React.useState([]);

  const headCells = [
    {
      id: "no",
      numeric: false,
      disablePadding: true,
      label: t("genboq.table.header.no"),
    },
    {
      id: "item",
      numeric: false,
      disablePadding: true,
      label: t("genboq.table.header.item"),
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      label: t("genboq.table.header.description"),
    },
    {
      id: "model",
      numeric: false,
      disablePadding: false,
      label: t("genboq.table.header.model"),
    },
    {
      id: "uom",
      numeric: false,
      disablePadding: false,
      label: t("genboq.table.header.uom"),
    },
    {
      id: "qty",
      numeric: true,
      disablePadding: false,
      label: t("genboq.table.header.qty"),
    },
    {
      id: "uprice",
      numeric: true,
      disablePadding: false,
      label: t("genboq.table.header.price"),
    },
    {
      id: "PriceHomepro",
      numeric: true,
      disablePadding: false,
      label: t("grounding.table.header.priceHome"),
    },
    {
      id: "PriceThaiWat",
      numeric: true,
      disablePadding: false,
      label: t("grounding.table.header.priceThai"),
    },
    {
      id: "PriceBoon",
      numeric: true,
      disablePadding: false,
      label: t("grounding.table.header.priceBoon"),
    },
    {
      id: "Other",
      numeric: true,
      disablePadding: false,
      label: t("grounding.table.header.priceOth"),
    },
    {
      id: "total",
      numeric: true,
      disablePadding: false,
      label: t("genboq.table.header.total"),
    },
    {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: t("genboq.table.header.action"),
    },
  ];

  const handleSelect = (id) => {
    // Add condition auto select sub seq when select main topic (INT number)
    // Get selected seq
    const selRow = boqData.filter((item) => item.id == id);
    const selSeq = selRow[0].seq;
    const isInteger = Number.isInteger(selSeq);

    let newSelected;

    if (isInteger) {
      // If the ID is an integer, create a list of related float IDs
      const floatIds = boqData.filter((item) => Math.floor(item.seq) == selSeq);
      const allRelatedIds = floatIds.map((item) => {
        return item.id;
      });

      newSelected = selected.includes(id)
        ? selected.filter((item) => !allRelatedIds.includes(item))
        : [...new Set([...selected, ...allRelatedIds])];
    } else {
      // Get the integer ID of float ID
      const filteredInt = boqData.filter(
        (item) => item.seq == Math.floor(selSeq)
      );
      const intID = filteredInt ? filteredInt[0].id : null;

      // If the ID is a float and the integer ID is selected, un-selected the integer.
      // If the ID is a float, just add or remove it
      newSelected = selected.includes(id)
        ? selected.filter((item) => item !== id && item !== intID)
        : [...selected, id];
    }
    setSelected(newSelected);
  };

  // Add product modal
  const [openModalAddProduct, setOpenModalAddProduct] = useState(false);
  const handleOpenModalAddProduct = () => {
    if (boqData.length > 0) {
      setOpenModalAddProduct(true);
    }
  };
  const handleCloseModalAddProduct = () => {
    setOpenModalAddProduct(false);
    appendProduct(texts);
    setTexts([]);
  };
  function appendProduct(products) {
    const id = boqData.length;

    const addProducts = products.map((item, index) => {
      return {
        id: id + index,
        seq:
          boqData.length > 0
            ? Math.floor(boqData[id - 1].seq) + 1 + index
            : 1 + index,
        item: item.itemname,
        description: item.ItemDescription,
        // brand: "",
        brand: item.brand,
        model: item.model, // Add model
        uom: item.UoMItem,
        qty: 1,
        mat_cost: item.material_Price,
        mat_total: item.material_Price,
        // Add labor cost of each material
        mat_lab_cost: item.MaterialLaborCost,
        mat_lab_total: item.MaterialLaborCost,

        lab_cost: null,
        lab_total: null,
        // Add labor cost of each material
        unit_cost: item.material_Price + item.MaterialLaborCost,
        total: item.material_Price + item.MaterialLaborCost,

        matPriceHome: item.matPriceHome,
        matPriceThai: item.matPriceThai,
        matPriceBoon: item.matPriceBoon,
        matPriceOth: item.matPriceOth,
        matPriceOth2: item.matPriceOth2,

        add_mat: true, // for verify material when edit row
      };
    });

    addProducts.map((item) => {
      boqData.push(item);
    });
  }

  // For gen boq but use product instead
  function extractProductData(products) {
    // First use for LBD only
    let id = 0;

    const addProducts = products.map((item, index) => {
      return {
        id: id + index,
        seq: 1 + index,
        item: item.itemname,
        description: item.ItemDescription,
        // brand: "",
        brand: item.brand,
        model: item.model, // Add model
        uom: item.UoMItem,
        qty: 1,
        mat_cost: item.material_Price,
        mat_total: item.material_Price,
        // Add labor cost of each material
        mat_lab_cost: item.MaterialLaborCost,
        mat_lab_total: item.MaterialLaborCost,

        lab_cost: null,
        lab_total: null,
        // Add labor cost of each material
        unit_cost: item.material_Price + item.MaterialLaborCost,
        total: item.material_Price + item.MaterialLaborCost,

        matPriceHome: item.matPriceHome,
        matPriceThai: item.matPriceThai,
        matPriceBoon: item.matPriceBoon,
        matPriceOth: item.matPriceOth,
        matPriceOth2: item.matPriceOth2,

        add_mat: true, // for verify material when edit row
      };
    });

    return addProducts;
  }

  // Search more modal
  const [openModalSearchMore, setOpenModalSearchMore] = useState(false);
  const handleOpenModalSearchMore = () => {
    setOpenModalSearchMore(true);
  };
  const handleCloseModalSearchMore = () => setOpenModalSearchMore(false);

  const [texts, setTexts] = useState([]);
  const handleAddProduct = (newText) => {
    setTexts((prevTexts) => [...prevTexts, newText]); // Add new text to the list
  };
  const [jobs, setJobs] = useState([]);
  const handleAddJob = (newJob) => {
    setJobs((prevJobs) => [...prevJobs, newJob]); // Add new job to the list
  };

  const handleSearchMore = (newSearch) => {
    appendJobWithProducts(newSearch);

    // Clear old checkbox data for refresh data in the table
    setSelected([]);
  };

  // Add job modal
  const [openModalAddJob, setOpenModalAddJob] = useState(false);
  const handleOpenModalAddJob = () => {
    if (boqData.length > 0) {
      setOpenModalAddJob(true);
    }
  };
  const handleCloseModalAddJob = () => {
    setOpenModalAddJob(false);
    appendJobWithProducts(jobs);
    setJobs([]);
  };

  function appendJobWithProducts(newData) {
    let id = boqData.length;
    const nextSeq = Math.floor(boqData[id - 1].seq) + 1;

    let addJobs = [];
    for (let i = 0; i < newData.length; i++) {
      let tmpData = {};
      tmpData.group_id = newData[i].GroupID; // Use for verify duplicate data after Search More
      tmpData.id = id++;
      tmpData.seq = Number(nextSeq + i);
      tmpData.item = newData[i].GroupName;
      tmpData.description = newData[i].GroupDescribe;
      // tmpData.brand = "";
      tmpData.brand = null;
      tmpData.uom = newData[i].UoMGroup;
      tmpData.qty = newData[i].UnitGroup;
      tmpData.mat_cost = null;
      tmpData.mat_total = null;
      tmpData.lab_cost = newData[i].LaborCost;
      tmpData.lab_total = newData[i].LaborCost * newData[i].UnitGroup;
      tmpData.unit_cost = newData[i].LaborCost;
      tmpData.total = newData[i].LaborCost * newData[i].UnitGroup;
      tmpData.matPriceHome = null;
      tmpData.matPriceThai = null;
      tmpData.matPriceBoon = null;
      tmpData.matPriceOth = null;
      tmpData.matPriceOth2 = null;
      // Add model
      tmpData.model = null;

      addJobs.push(tmpData);

      if (newData[i].item_material.length !== 0) {
        for (let j = 0; j < newData[i].item_material.length; j++) {
          let matData = {};
          const decSeqLength = (j + 1).toString().length;
          matData.group_id = null;
          matData.id = id++;
          matData.seq =
            decSeqLength > 1
              ? Number(`${nextSeq + i}.${j + 1}`).toFixed(decSeqLength)
              : Number(`${nextSeq + i}.${j + 1}`);
          matData.item = newData[i].item_material[j].itemname;
          matData.description = newData[i].item_material[j].ItemDescription;
          // matData.brand = "";
          matData.brand = newData[i].item_material[j].brand;
          matData.uom = newData[i].item_material[j].UoMItem;
          matData.qty = newData[i].item_material[j].amount;
          matData.mat_cost = newData[i].item_material[j].material_Price;
          matData.mat_total =
            newData[i].item_material[j].amount *
            newData[i].item_material[j].material_Price;
          //  Add labor cost of each material
          matData.mat_lab_cost = newData[i].item_material[j].MaterialLaborCost;
          matData.mat_lab_total =
            newData[i].item_material[j].amount *
            newData[i].item_material[j].MaterialLaborCost;
          matData.lab_cost = null;
          matData.lab_total = null;
          // Add labor cost of each material
          matData.unit_cost =
            newData[i].item_material[j].material_Price +
            newData[i].item_material[j].MaterialLaborCost;
          matData.total =
            newData[i].item_material[j].amount *
              newData[i].item_material[j].material_Price +
            newData[i].item_material[j].amount *
              newData[i].item_material[j].MaterialLaborCost;
          // Add price of 4 supplier
          matData.matPriceHome = newData[i].item_material[j].matPriceHome;
          matData.matPriceThai = newData[i].item_material[j].matPriceThai;
          matData.matPriceBoon = newData[i].item_material[j].matPriceBoon;
          matData.matPriceOth = newData[i].item_material[j].matPriceOth;
          matData.matPriceOth2 = newData[i].item_material[j].matPriceOth2;
          // Add model
          matData.model = newData[i].item_material[j].model;

          addJobs.push(matData);
        }
      }
    }

    addJobs.map((item) => {
      boqData.push(item);
    });
  }

  const styles = {
    BtnIcon: {
      width: 32,
      height: 32,
    },
  };

  const [inputValue, setInputValue] = useState("");
  const [searchHistory, setSearchHistory] = useState([]);

  // Load search history from session storage on component mount
  React.useEffect(() => {
    const history = JSON.parse(sessionStorage.getItem("searchHistory")) || [];
    setSearchHistory(history);
  }, []);

  // Clear data when change team tab
  React.useEffect(() => {
    setBoqData([]);
    setSelected([]);
    setInputValue("");
  }, [team]);

  const [errorMsg, setErrorMsg] = useState("");
  const [sumErrorMsg, setSumErrorMsg] = useState("");

  const [loading, setLoading] = useState(false);

  const [openModalMultidelete, setOpenModalMultidelete] = useState(false);
  const [loadingbuttondelete, setloadingbuttondelete] = useState(false);

  const handleOpenModalMultidelete = () => {
    setOpenModalMultidelete(true);
    setloadingbuttondelete(false);
  };
  const handleCloseModalMultidelete = () => setOpenModalMultidelete(false);

  const handleClickModalMultidelete = () => {
    setloadingbuttondelete(true);
    deleteMultiRows();
  };

  const deleteMultiRows = () => {
    // Sort the selected row
    const sortedSelected = selected.sort((a, b) => a - b);

    // Filter out the item you want to delete with id
    const filteredData = boqData.filter(
      (item) => !sortedSelected.includes(item.id)
    );

    // re-arrange seq & id after delete row
    let newData = [];
    filteredData.map((row, index) => {
      index !== row.id
        ? Number.isInteger(row.seq)
          ? newData.length > 0
            ? Number.isInteger(newData[newData.length - 1].seq)
              ? newData.push({
                  ...row,
                  id: index,
                  seq: newData[newData.length - 1].seq + 1,
                })
              : newData.push({
                  ...row,
                  id: index,
                  seq: Math.floor(newData[newData.length - 1].seq) + 1,
                })
            : newData.push({
                ...row,
                id: index,
                seq: 1,
              })
          : Number.isInteger(newData[newData.length - 1].seq)
          ? newData.push({
              ...row,
              id: index,
              seq: (Math.floor(newData[newData.length - 1].seq * 10) + 1) / 10,
            })
          : newData.push({
              ...row,
              id: index,
              seq: Number(
                `${Math.floor(newData[newData.length - 1].seq)}.${
                  Number(
                    String(newData[newData.length - 1].seq).split(".")[1]
                  ) + 1
                }`
              ).toFixed(
                String(
                  Number(
                    String(newData[newData.length - 1].seq).split(".")[1]
                  ) + 1
                ).length
              ),
            })
        : newData.push(row);
    });

    setBoqData(newData);

    setloadingbuttondelete(false);
    handleCloseModalMultidelete();
    setSelected([]);
  };

  // Export boq
  const [openConfirmExport, setOpenConfirmExport] = useState(false);
  const handleOpenConfirmExport = () => {
    setLoadingBtnExport(false);
    if (boqData.length > 0) {
      setOpenConfirmExport(true);
    }
  };
  const handleCloseConfirmExport = () => {
    setOpenConfirmExport(false);
    setErrorMsg("");
  };
  const [loadingBtnExport, setLoadingBtnExport] = useState(false);
  const handleClickModalExport = () => {
    setLoadingBtnExport(true);
    exportBOQ();
  };

  async function exportBOQ() {
    // Verify team tabs for check required export TOR form (LBD is not required, Other teams require export TOR form)
    // Verify TOR form exist in bucket
    const torFile = dataEntry.current?.tor;
    if (torFile !== null) {
      const dataForm = {
        filename: torFile,
      };
      let isError = false;
      await checkTorFormsExist(dataForm).then((res) => {
        if (res && res.status === 200 && res.data.success === true) {
          if (res.data.file_exist === false) {
            const msg = `${t("genboq.err.exportboq.msg1")} ${torFile} ${t(
              "genboq.err.exportboq.msg2"
            )}`;
            // Alert to user
            Swal.fire({
              icon: "error",
              // title: "Export failed!",
              // html: `TOR file not found, please contact admin to check the <br> "${torFile}" file in the bucket.`,
              title: t("genboq.err.exportboq.title"),
              html: msg,
            });
            isError = true;
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.message,
          });
          console.log(`error checkTorFormsExist:`, res);
          isError = true;
        }
      });
      if (isError) {
        setExporting(false);
        return;
      }
    }

    // Export BOQ with input data and logo
    const inputData = dataEntry.current;

    // let boqName = "default-boq";
    // let torName = "default-tor";
    // let qtName = "default-qt";
    let boqName = null;
    let torName = null;
    let qtName = null;

    // BOQ
    boqName = await exportFormBOQ(
      boqData,
      userData.userID,
      userData.name,
      inputData
    );
    // Quotation
    qtName = await exportFormQT(
      boqData,
      userData.userID,
      userData.name,
      inputData
    );
    // TOR
    if (torFile !== null) {
      torName = await exportFormTOR(userData.userID, userData.name, inputData);
    }

    // Add log after generate BOQ file link
    const allFiles = { boqFile: boqName, qtFile: qtName, torFile: torName };
    addLog("BOQ", "Exported file", allFiles);

    setExporting(false);
  }

  // Snack Bar
  const [openSnack, setOpenSnack] = useState(false);

  const handleClickSnack = () => {
    setOpenSnack(true);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnack(false);
  };

  const genBOQ = async (txt) => {
    setLoading(true);

    const role = dataAccessPermission("OWNER");

    // console.log("isCallGenBOQ", isCallGenBOQ);
    // Verify team tabs for separate access api (only LBD call dataProductList, Other teams call generateBOQ)
    if (isCallGenBOQ) {
      // For other teams
      let dataForm = {
        UserPrompt: txt,
        UserRole: role,
        maxSearchLoop: 2,
      };

      await generateBOQ(dataForm).then((res) => {
        if (res && res?.status === 200) {
          const exdata = extractData(res.data); // OK

          setBoqData(exdata);
        } else if (res?.status === 401) {
          signOut();
        } else if (res === undefined) {
          Swal.fire({
            icon: "error",
            title: "Database connection failed",
            text: "Please contact administrator",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res?.data.message,
          });
          console.log(`error boqList:`, res);
        }
        setLoading(false);
      });
    } else {
      // For LBD only
      let qString = `?page=1&perpage=-1`;
      qString += `&UserRole=${role}`;
      if (txt) qString = qString + "&KeyWord=" + txt;

      await dataProductList(qString).then((res) => {
        if (res && res?.status === 200) {
          const exdata = extractProductData(res.data.data);

          setBoqData(exdata);
        } else if (res?.status === 401) {
          signOut();
        } else if (res === undefined) {
          Swal.fire({
            icon: "error",
            title: "Database connection failed",
            text: "Please contact administrator",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res?.data.message,
          });
          console.log(`error boqList:`, res);
        }
        setLoading(false);
      });
    }
  };

  //  Add labor cost of each material
  function extractData(aiData) {
    // Convert aiData to rowData [OK: item_material included]
    let rowData = [];
    let id = 0;
    for (let i = 0; i < aiData.length; i++) {
      let tmpData = {};
      tmpData.group_id = aiData[i].GroupID; // Use for verify duplicate data after Search More
      tmpData.id = id++;
      tmpData.seq = Number(i + 1);
      tmpData.item = aiData[i].GroupName;
      tmpData.description = aiData[i].GroupDescribe;
      // tmpData.brand = "";
      tmpData.brand = aiData[i].brand;
      tmpData.model = aiData[i].model; // Add model
      tmpData.uom = aiData[i].UoMGroup;
      tmpData.qty = aiData[i].UnitGroup;
      tmpData.mat_cost = null;
      tmpData.mat_total = null;
      tmpData.lab_cost = aiData[i].LaborCost;
      tmpData.lab_total = aiData[i].LaborCost * aiData[i].UnitGroup;
      tmpData.unit_cost = aiData[i].LaborCost;
      tmpData.total = aiData[i].LaborCost * aiData[i].UnitGroup;
      tmpData.matPriceHome = null;
      tmpData.matPriceThai = null;
      tmpData.matPriceBoon = null;
      tmpData.matPriceOth = null;
      tmpData.matPriceOth2 = null;
      rowData.push(tmpData);

      if (aiData[i].item_material.length !== 0) {
        for (let j = 0; j < aiData[i].item_material.length; j++) {
          let matData = {};
          const decSeqLength = (j + 1).toString().length;
          matData.group_id = null;
          matData.id = id++;
          matData.seq =
            decSeqLength > 1
              ? Number(`${i + 1}.${j + 1}`).toFixed(decSeqLength)
              : Number(`${i + 1}.${j + 1}`); // Solve bug
          matData.item = aiData[i].item_material[j].itemname;
          matData.description = aiData[i].item_material[j].ItemDescription;
          // matData.brand = "";
          matData.brand = aiData[i].item_material[j].brand;
          matData.model = aiData[i].item_material[j].model; // Add model
          matData.uom = aiData[i].item_material[j].UoMItem;
          matData.qty = aiData[i].item_material[j].amount;
          matData.mat_cost = aiData[i].item_material[j].material_Price;
          matData.mat_total =
            aiData[i].item_material[j].amount *
            aiData[i].item_material[j].material_Price;
          //  Add labor cost of each material
          matData.mat_lab_cost = aiData[i].item_material[j].MaterialLaborCost;
          matData.mat_lab_total =
            aiData[i].item_material[j].amount *
            aiData[i].item_material[j].MaterialLaborCost;

          matData.lab_cost = null;
          matData.lab_total = null;
          //  Add labor cost of each material
          matData.unit_cost =
            aiData[i].item_material[j].material_Price +
            aiData[i].item_material[j].MaterialLaborCost;
          matData.total =
            aiData[i].item_material[j].amount *
              aiData[i].item_material[j].material_Price +
            aiData[i].item_material[j].amount *
              aiData[i].item_material[j].MaterialLaborCost;

          // Add price of 4 supplier
          matData.matPriceHome = aiData[i].item_material[j].matPriceHome;
          matData.matPriceThai = aiData[i].item_material[j].matPriceThai;
          matData.matPriceBoon = aiData[i].item_material[j].matPriceBoon;
          matData.matPriceOth = aiData[i].item_material[j].matPriceOth;
          matData.matPriceOth2 = aiData[i].item_material[j].matPriceOth2;

          rowData.push(matData);
        }
      }
    }
    return rowData;
  }

  const [highlightedInput, setHighlightedInput] = useState(null);
  const handleHighlightChange = (event, option, reason) => {
    if (option && reason === "keyboard") {
      setHighlightedInput(option);
    }
  };
  const handleOnClose = (event, option, reason, details) => {
    if (option && event.key === "Enter") {
      setInputValue(highlightedInput);
      setHighlightedInput(null);
    }
  };

  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue);
    if (newInputValue === "") {
      handleClearGenBoq();
    }
  };

  const handleKeyDown = async (event) => {
    if (event.key === "Enter" && inputValue && !highlightedInput && !loading) {
      // Clear old checkbox data
      setSelected([]);

      // stores the list of search input
      if (inputValue && !searchHistory.includes(inputValue)) {
        // // Update search history
        const updatedHistory = [...searchHistory, inputValue];
        setSearchHistory(updatedHistory);

        // Save to session storage
        sessionStorage.setItem("searchHistory", JSON.stringify(updatedHistory));
      }

      await genBOQ(inputValue);
      addLog("BOQ", "Create", null);
    }
  };

  const handleClearGenBoq = () => {
    setBoqData([]);
    setInputValue("");
  };

  const [isLoading, setIsLoading] = React.useState(false);
  const [editValueItem, setEditValueItem] = useState("");
  const [editValueDescription, setEditValueDescription] = useState("");
  const [editValueModel, setEditValueModel] = useState("");
  const [editValueUom, setEditValueUom] = useState("");
  const [editValueQty, setEditValueQty] = useState("");
  const [editValueUnitPrice, setEditValueUnitPrice] = useState("");
  const [editValueMaterialPrice, setEditValueMaterialPrice] = useState("");
  const [editValueMatLaborPrice, setEditValueMatLaborPrice] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [isJobEdit, setIsJobEdit] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [dataID, setDataID] = useState("");
  const [dataRow, setDataRow] = useState([]);
  const handleEditRow = (id) => {
    let seq = null;
    let isMaterial = false;
    boqData.map((item, i) => {
      if (item.id === id) {
        setEditValueItem(item.item);
        setEditValueDescription(item.description);
        setEditValueModel(item.model);
        setEditValueUom(item.uom);
        setEditValueQty(item.qty);
        setEditValueUnitPrice(item.unit_cost);
        setEditValueMaterialPrice(item.mat_cost);
        setEditValueMatLaborPrice(item.mat_lab_cost);
        seq = item.seq;
        isMaterial = item.add_mat;
      }
    });

    setIsEditing(true);
    setRowIndex(id);
    setDataID(id);

    if (Number.isInteger(seq) && !isMaterial) {
      setIsJobEdit(true);
    } else {
      setIsJobEdit(false);
    }
  };

  let NumberForm = new Intl.NumberFormat("th-TH", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

  function updRowData(id, seq) {
    setIsLoading(true);

    // Verify add material row
    const addMat = boqData[id].add_mat ? boqData[id].add_mat : false;

    // Edit separate materail & labor cost
    let matPrice = 0;
    let matLabPrice = 0;
    let editPrice = 0;
    if (Number.isInteger(seq) && !addMat) {
      // job
      editPrice = editValueUnitPrice ? editValueUnitPrice : 0;
    } else {
      // material
      matPrice = editValueMaterialPrice ? editValueMaterialPrice : 0;
      matLabPrice = editValueMatLaborPrice ? editValueMatLaborPrice : 0;
      editPrice = parseFloat(matPrice) + parseFloat(matLabPrice);
    }

    // Get from selecting row to approve
    const editData = {
      item: editValueItem ? editValueItem : "",
      description: editValueDescription ? editValueDescription : "",
      model: editValueModel ? editValueModel : "", // Add model
      uom: editValueUom ? editValueUom : "",
      qty: editValueQty ? editValueQty : 0,
      uprice: parseFloat(editPrice),
      umatcost: parseFloat(matPrice),
      umatlabcost: parseFloat(matLabPrice),
    };

    // Update the object
    if (Number.isInteger(boqData[id].seq) && !addMat) {
      // Job
      boqData[id] = {
        ...boqData[id],
        item: editData.item,
        description: editData.description,
        model: editData.model, // Add model
        uom: editData.uom,
        qty: parseInt(editData.qty),
        unit_cost: parseFloat((editData.uprice * 1).toFixed(2)),
        total: parseFloat((editData.uprice * editData.qty).toFixed(2)),
        lab_cost: parseFloat((editData.uprice * 1).toFixed(2)),
        lab_total: parseFloat((editData.uprice * editData.qty).toFixed(2)),
      };
    } else {
      boqData[id] = {
        ...boqData[id],
        item: editData.item,
        description: editData.description,
        model: editData.model, // Add model
        uom: editData.uom,
        qty: parseInt(editData.qty),
        unit_cost: parseFloat((editData.uprice * 1).toFixed(2)),
        total: parseFloat((editData.uprice * editData.qty).toFixed(2)),
        mat_cost: parseFloat((editData.umatcost * 1).toFixed(2)),
        mat_total: parseFloat((editData.umatcost * editData.qty).toFixed(2)),
        mat_lab_cost: parseFloat((editData.umatlabcost * 1).toFixed(2)),
        mat_lab_total: parseFloat(
          (editData.umatlabcost * editData.qty).toFixed(2)
        ),
      };
    }
    addLog("BOQ", "Edit", null);

    setIsLoading(false);
    setEditValueItem("");
    setEditValueDescription("");
    setEditValueModel("");
    setEditValueUom("");
    setEditValueQty("");
    setEditValueUnitPrice("");
    setEditValueMaterialPrice("");
    setEditValueMatLaborPrice("");
    setIsEditing(false);
  }

  // Pre-export data entry modal
  const [openModalDataEntry, setOpenModalDataEntry] = useState(false);
  const handleOpenModalDataEntry = () => {
    if (boqData.length > 0) {
      setOpenModalDataEntry(true);
    }
  };
  const handleCloseModalDataEntry = () => {
    setOpenModalDataEntry(false);
  };
  const dataEntry = useRef(null);
  const [exporting, setExporting] = useState(false);
  const handleDataEntry = (preData) => {
    dataEntry.current = preData;
    handleCloseModalDataEntry();
    setExporting(true);

    exportBOQ();
  };

  return team !== "lbd" &&
    team !== "lbm-lg" &&
    team !== "lbm-id" &&
    team !== "ied" &&
    team !== "up-power" &&
    team !== "up-water" &&
    team !== "moblx" ? (
    <PageNotFound />
  ) : userRole.role.includes(teamParam) || userRole.role === "admin" ? (
    <Box
      style={{
        margin: "65px 0px 0px 0px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Snackbar
        open={openSnack}
        autoHideDuration={10000}
        onClose={handleCloseSnack}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnack}
          severity="warning"
          sx={{ width: "100%", fontSize: "16px", padding: 2 }}
        >
          {sumErrorMsg}
        </Alert>
      </Snackbar>

      {/* ////////////////////////// Backdrop for exporting //////////////////////////*/}
      <Backdrop
        sx={(theme) => ({
          color: "#fff",
          zIndex: theme.zIndex.drawer + 1,
        })}
        open={exporting}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <CircularProgress color="inherit" />
          <Typography variant="h6" sx={{ marginLeft: 2 }}>
            Exporting...
          </Typography>
        </Box>
      </Backdrop>

      {/*  ////////////////////////// Search Box ////////////////////////// */}
      <Box
        sx={{
          display: "flex",
          paddingBottom: "20px",
          justifyContent: "space-between",
          alignItems: "center",
          alignContent: "center",
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Box
            sx={{
              width: { lg: 800, md: 500 },
              display: "flex",
              mr: 2,
            }}
          >
            <Autocomplete
              freeSolo
              id="free-solo-2-demo"
              options={searchHistory.map((option) => option)}
              value={inputValue}
              onChange={(event, newValue) => {
                setInputValue(newValue);
              }}
              onInputChange={handleInputChange}
              onKeyDown={handleKeyDown}
              onHighlightChange={handleHighlightChange}
              onClose={handleOnClose}
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      borderRadius: "10px",
                      backgroundColor: "#F0F0F0",
                      paddingLeft: "15px",
                      fontSize: "medium",
                    },
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderColor: "white", // white border for the input field
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                  }}
                />
              )}
              fullWidth
            />
          </Box>
        </Box>
        {/*  ////////////////////////// Export and Delete Button ////////////////////////// */}
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          {selected.length > 0 ? (
            <Box sx={{ ml: 2 }}>
              <Button
                variant="contained"
                size="small"
                startIcon={<DeleteIcon />}
                style={{
                  backgroundColor: "#7399D1",
                  borderRadius: "10px",
                  height: "45px",
                  textTransform: "none",
                  minWidth: "100px",
                }}
                onClick={handleOpenModalMultidelete}
              >
                {t("common.button.del")}
              </Button>
            </Box>
          ) : (
            ""
          )}

          <Box sx={{ ml: 2 }}>
            <Button
              variant="contained"
              size="small"
              startIcon={<img src={BtnUpdFileIcon} style={styles.BtnIcon} />}
              style={{
                backgroundColor: "#7399D1",
                color: "#FFFFFF",
                borderRadius: "10px",
                height: "45px",
                textTransform: "none",
              }}
              // onClick={handleOpenConfirmExport}
              onClick={handleOpenModalDataEntry}
            >
              {t("genboq.button.export")}
            </Button>
          </Box>
        </Box>
      </Box>

      {/* ======================= Table ==================== */}
      <TableContainer>
        <Table sx={{ minWidth: 750 }}>
          <TableHead>
            <TableRow>
              <TableCell
                padding="checkbox"
                style={{
                  borderTop: "2px solid gray",
                  borderBottom: "none",
                }}
              >
                <Checkbox
                  checked={
                    boqData.length ? selected.length === boqData.length : false
                  }
                  onChange={() =>
                    setSelected(
                      boqData.length
                        ? selected.length === boqData.length
                          ? []
                          : boqData.map((item) => item.id)
                        : []
                    )
                  }
                />
              </TableCell>
              {headCells.map((headCell) => (
                <TableCell
                  key={headCell.id}
                  align={headCell.numeric ? "right" : "left"}
                  padding={headCell.disablePadding ? "none" : "normal"}
                  sx={{
                    color: "#1D589D",
                    fontWeight: "bold",
                    padding: "10px",
                  }}
                  style={{
                    borderTop: "2px solid gray",
                    borderBottom: "none",
                  }}
                >
                  {headCell.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={13}>
                  <Backdrop
                    sx={(theme) => ({
                      color: "#fff",
                      zIndex: theme.zIndex.drawer + 1,
                    })}
                    open={loading}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <CircularProgress color="inherit" />
                      <Typography variant="h6" sx={{ marginLeft: 2 }}>
                        Generating...
                      </Typography>
                    </Box>
                  </Backdrop>
                </TableCell>
              </TableRow>
            ) : (
              <>
                {boqData.length > 0 &&
                  boqData.map((row, index) => {
                    return (
                      <TableRow
                        tabIndex={-1}
                        key={row.id}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "#F0F0F0" : "white",
                        }}
                      >
                        <TableCell
                          padding="checkbox"
                          style={{ border: "none" }}
                        >
                          <Checkbox
                            checked={selected.includes(row.id)}
                            onChange={() => handleSelect(row.id)}
                          />
                        </TableCell>
                        <TableCell width={50} style={{ border: "none" }}>
                          <Typography>{row.seq}</Typography>
                        </TableCell>

                        <TableCell
                          component="th"
                          scope="row"
                          padding="none"
                          width={350}
                          style={{
                            border: "none",
                            maxWidth: "500px",
                            minWidth: "300px",
                          }}
                        >
                          {isEditing && rowIndex === row.id ? (
                            <Box component="form" noValidate autoComplete="off">
                              <TextField
                                multiline
                                minRows={1}
                                maxRows={2}
                                fullWidth
                                id="item"
                                size="small"
                                defaultValue={editValueItem}
                                onChange={(event) => {
                                  setEditValueItem(event.target.value);
                                }}
                              />
                            </Box>
                          ) : (
                            <Typography>{row.item}</Typography>
                          )}
                        </TableCell>

                        <TableCell
                          align="left"
                          style={{
                            border: "none",
                            minWidth: "300px",
                          }}
                        >
                          {isEditing && rowIndex === row.id ? (
                            <Box component="form" noValidate autoComplete="off">
                              <TextField
                                multiline
                                minRows={3}
                                maxRows={6}
                                fullWidth
                                id="description"
                                size="small"
                                defaultValue={editValueDescription}
                                onChange={(event) => {
                                  setEditValueDescription(event.target.value);
                                }}
                              />
                            </Box>
                          ) : (
                            <Typography sx={{ whiteSpace: "pre-line" }}>
                              {row.description}
                            </Typography>
                          )}
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{
                            border: "none",
                            minWidth: "100px",
                            maxWidth: "120px",
                          }}
                        >
                          {isEditing && rowIndex === row.id ? (
                            <Box component="form" noValidate autoComplete="off">
                              <TextField
                                multiline
                                minRows={1}
                                maxRows={2}
                                fullWidth
                                id="model"
                                size="small"
                                defaultValue={editValueModel}
                                onChange={(event) => {
                                  setEditValueModel(event.target.value);
                                }}
                              />
                            </Box>
                          ) : (
                            <Typography
                              sx={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                WebkitLineClamp: 2, // Limits to 2 lines
                                textOverflow: "ellipsis",
                              }}
                            >
                              {row.model}
                            </Typography>
                          )}
                        </TableCell>

                        <TableCell
                          align="left"
                          width={120}
                          style={{
                            border: "none",
                            minWidth: "100px",
                            maxWidth: "120px",
                          }}
                        >
                          {isEditing && rowIndex === row.id ? (
                            <Box component="form" noValidate autoComplete="off">
                              <TextField
                                id="uom"
                                size="small"
                                defaultValue={editValueUom}
                                onChange={(event) => {
                                  setEditValueUom(event.target.value);
                                }}
                              />
                            </Box>
                          ) : (
                            <Typography>{row.uom} </Typography>
                          )}
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{
                            border: "none",
                            minWidth: "70px",
                          }}
                        >
                          {isEditing && rowIndex === row.id ? (
                            <Box component="form" noValidate autoComplete="off">
                              <TextField
                                id="qty"
                                type="number"
                                size="small"
                                defaultValue={editValueQty}
                                onChange={(event) => {
                                  setEditValueQty(event.target.value);
                                }}
                                sx={{
                                  "& .MuiInputBase-input": {
                                    textAlign: "right", // Align the input text to the left
                                  },
                                }}
                              />
                            </Box>
                          ) : (
                            <Typography>{row.qty}</Typography>
                          )}
                        </TableCell>

                        <TableCell
                          align="right"
                          style={{
                            border: "none",
                            minWidth: "140px",
                            maxWidth: "200px",
                          }}
                        >
                          {isEditing && rowIndex === row.id ? (
                            isJobEdit ? (
                              // <Box
                              //   component="form"
                              //   noValidate
                              //   autoComplete="off"
                              // >
                              //   <TextField
                              //     label="Job labor cost"
                              //     id="unit_price"
                              //     type="number"
                              //     size="small"
                              //     defaultValue={editValueUnitPrice}
                              //     onChange={(event) => {
                              //       setEditValueUnitPrice(event.target.value);
                              //     }}
                              //     sx={{
                              //       "& .MuiInputBase-input": {
                              //         textAlign: "right", // Align the input text to the left
                              //       },
                              //     }}
                              //   />
                              // </Box>

                              <Typography>
                                {NumberForm.format(row.unit_cost)}
                              </Typography>
                            ) : (
                              <Box
                                component="form"
                                noValidate
                                autoComplete="off"
                              >
                                <Box sx={{ marginBottom: "10px" }}>
                                  <TextField
                                    label="Material cost"
                                    id="mat_cost"
                                    type="number"
                                    size="small"
                                    defaultValue={editValueMaterialPrice}
                                    onChange={(event) => {
                                      setEditValueMaterialPrice(
                                        event.target.value
                                      );
                                    }}
                                    sx={{
                                      "& .MuiInputBase-input": {
                                        textAlign: "right", // Align the input text to the left
                                      },
                                    }}
                                  />
                                </Box>
                                <Box>
                                  <TextField
                                    label="Labor cost"
                                    id="mat_lab_cost"
                                    type="number"
                                    size="small"
                                    defaultValue={editValueMatLaborPrice}
                                    onChange={(event) => {
                                      setEditValueMatLaborPrice(
                                        event.target.value
                                      );
                                    }}
                                    sx={{
                                      "& .MuiInputBase-input": {
                                        textAlign: "right", // Align the input text to the left
                                      },
                                    }}
                                  />
                                </Box>
                              </Box>
                            )
                          ) : (
                            <Typography>
                              {NumberForm.format(row.unit_cost)}
                            </Typography>
                          )}
                        </TableCell>

                        <TableCell
                          align="right"
                          width={150}
                          style={{ border: "none", maxWidth: "150px" }}
                        >
                          <Typography>
                            {NumberForm.format(row.matPriceHome)}
                          </Typography>
                        </TableCell>
                        <TableCell
                          align="right"
                          width={150}
                          style={{ border: "none", maxWidth: "150px" }}
                        >
                          <Typography>
                            {NumberForm.format(row.matPriceThai)}
                          </Typography>
                        </TableCell>
                        <TableCell
                          align="right"
                          width={150}
                          style={{ border: "none", maxWidth: "150px" }}
                        >
                          <Typography>
                            {NumberForm.format(row.matPriceBoon)}
                          </Typography>
                        </TableCell>
                        <TableCell
                          align="right"
                          width={150}
                          style={{ border: "none", maxWidth: "150px" }}
                        >
                          <Typography>
                            {NumberForm.format(row.matPriceOth)}
                          </Typography>
                        </TableCell>

                        <TableCell
                          align="right"
                          width={150}
                          style={{ border: "none", maxWidth: "150px" }}
                        >
                          <Typography>
                            {NumberForm.format(row.total)}
                          </Typography>
                        </TableCell>

                        <TableCell style={{ border: "none" }}>
                          {isEditing && rowIndex === row.id ? (
                            <>
                              <LoadingButton
                                loading={isLoading}
                                loadingPosition="start"
                                startIcon={<SaveIcon />}
                                variant="contained"
                                onClick={(e) => updRowData(row.id, row.seq)}
                                size="small"
                              >
                                Save
                              </LoadingButton>

                              <Button
                                onClick={() => {
                                  setIsEditing(false);
                                }}
                                size="small"
                              >
                                Cancel
                              </Button>
                            </>
                          ) : (
                            <>
                              <IconButton
                                color="primary"
                                onClick={(event) => {
                                  handleEditRow(row.id);
                                }}
                              >
                                <EditIcon />
                              </IconButton>
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </>
            )}

            <TableRow
              style={{
                backgroundColor: boqData.length % 2 === 0 ? "#F0F0F0" : "white",
              }}
            >
              <TableCell rowSpan={2} />
              <TableCell colSpan={13}>
                {boqData && boqData.length > 0 ? (
                  <Box sx={{ display: "flex" }}>
                    <Box sx={{ paddingRight: "40px" }}>
                      <Button
                        variant="text"
                        style={{ textTransform: "none", fontSize: "16px" }}
                        size="small"
                        onClick={handleOpenModalAddProduct}
                      >
                        {t("genboq.button.addpro")}
                      </Button>
                    </Box>
                    <Box sx={{ paddingRight: "40px" }}>
                      <Button
                        variant="text"
                        style={{ textTransform: "none", fontSize: "16px" }}
                        size="small"
                        onClick={handleOpenModalAddJob}
                      >
                        {t("genboq.button.addjob")}
                      </Button>
                    </Box>
                    <Box sx={{ paddingRight: "40px" }}>
                      <SearchMore
                        initData={boqData}
                        onSearchMore={handleSearchMore}
                      />
                    </Box>
                  </Box>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
          </TableBody>
          <TableFooter>
            <TableRow
              style={{
                borderTop: "2px solid gray",
                borderBottom: "2px solid white",
              }}
            >
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell colSpan={4} align="right">
                <Typography
                  variant="subtitle1"
                  color="primary"
                  fontWeight="bold"
                >
                  {t("genboq.table.footer.txt")}
                </Typography>
              </TableCell>
              <TableCell
                align="right"
                sx={{ fontStyle: { color: "#000", fontSize: "20px" } }}
              >
                <Typography
                  variant="subtitle1"
                  color="primary"
                  fontWeight="bold"
                >
                  {boqData.length > 0 &&
                    NumberForm.format(
                      boqData.reduce((acc, item) => acc + item.total, 0)
                    )}
                </Typography>
              </TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>

      {/* /////////// Modal confirm Export BOQ /////////// */}
      <Modal open={openConfirmExport}>
        <Box sx={style}>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography marginTop={1} variant="h5" component="h2">
              {/* Export BOQ */}
              {t("genboq.popup.export.header")}
            </Typography>
            <IconButton size="large" onClick={handleCloseConfirmExport}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
          <Typography
            sx={{ mt: 3, color: "#616161" }}
            fontSize={14}
            fontWeight={300}
          >
            {/* Do you want to confirm Export BOQ ? */}
            {t("genboq.popup.export.txt1")}
          </Typography>
          <Box
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "5rem",
            }}
          >
            <LoadingButton
              onClick={handleClickModalExport}
              loading={loadingBtnExport}
              loadingPosition="start"
              startIcon={<img src={BtnUpdFileIcon} style={styles.BtnIcon} />}
              variant="contained"
              size="small"
            >
              {/* <span>Export</span> */}
              <span>{t("common.button.export")}</span>
            </LoadingButton>
            <Button
              style={{ marginLeft: 12 }}
              variant="outlined"
              size="middle"
              color="inherit"
              onClick={handleCloseConfirmExport}
            >
              <Typography fontSize={14}>{t("common.button.cancel")}</Typography>
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* /////////// Modal Add product /////////// */}
      <Dialog open={openModalAddProduct} fullWidth maxWidth="lg">
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <DialogTitle>{t("genboq.modal.addproduct.title")}</DialogTitle>
          <IconButton size="large" onClick={handleCloseModalAddProduct}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Box>
        <DialogContent>
          <AddProduct onAddProduct={handleAddProduct} />
        </DialogContent>
      </Dialog>

      {/* /////////// Modal Add job /////////// */}
      <Dialog open={openModalAddJob} fullWidth maxWidth="lg">
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <DialogTitle>{t("genboq.modal.addjob.title")}</DialogTitle>

          <IconButton size="large" onClick={handleCloseModalAddJob}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Box>
        <DialogContent>
          <AddJob onAddJob={handleAddJob} />
        </DialogContent>
      </Dialog>

      {/* /////////// Modal confirm multi files Delete /////////// */}
      <Modal open={openModalMultidelete}>
        <Box sx={styleModaldelete}>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography marginTop={1} variant="h5" component="h2">
              {t("genboq.popup.delete.header")}
            </Typography>
            <IconButton size="large" onClick={handleCloseModalMultidelete}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Typography
            sx={{ mt: 3, color: "#616161" }}
            fontSize={14}
            fontWeight={300}
          >
            {t("genboq.popup.delete.txt1")}
          </Typography>
          <Box
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "5rem",
            }}
          >
            <LoadingButton
              color="error"
              onClick={handleClickModalMultidelete}
              loading={loadingbuttondelete}
              loadingPosition="start"
              startIcon={<DeleteIcon />}
              variant="contained"
              size="medium"
            >
              {t("common.button.del")}
            </LoadingButton>
            <Button
              style={{ marginLeft: 12 }}
              variant="outlined"
              size="medium"
              color="inherit"
              onClick={handleCloseModalMultidelete}
            >
              <Typography fontSize={14}>{t("common.button.cancel")}</Typography>
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* /////////// Modal Pre-export data entry /////////// */}
      <Dialog open={openModalDataEntry} fullWidth maxWidth="sm">
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <DialogTitle>{t("genboq.modal.dataentry.title")}</DialogTitle>
          <IconButton size="large" onClick={handleCloseModalDataEntry}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Box>
        <DialogContent>
          <DataEntry
            onDataEntry={handleDataEntry}
            onCancel={handleCloseModalDataEntry}
            team={team}
          />
        </DialogContent>
      </Dialog>
    </Box>
  ) : (
    <Unauthorized />
  );
};
export default GenBOQ;
